import { render, staticRenderFns } from "./_base-infoauto-customer-modal.vue?vue&type=template&id=42876e46&scoped=true"
import script from "./_base-infoauto-customer-modal.vue?vue&type=script&lang=js"
export * from "./_base-infoauto-customer-modal.vue?vue&type=script&lang=js"
import style0 from "./_base-infoauto-customer-modal.vue?vue&type=style&index=0&id=42876e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42876e46",
  null
  
)

export default component.exports